export default __webpack_public_path__ + "static/media/la soufriere.799d66ae.jpg";